import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'invalidCode': '',
  'invalidIndex': '',
  'selectedOrder': null,
  'selectedValues': null,
  'errorCode': 0,
  'errorDescription': '',
};

export const providerPartVerification = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.RESTORE_PROVIDER_SUGGESTED_ORDERS]: (state, action) => (INITIAL_STATE),
    [ActionTypes.RESTORE_PROVIDER_MANUAL_ORDER]: (state, action) => (INITIAL_STATE),
    [ActionTypes.CLEAR_SELECTED_PROVIDER_ORDER_DETAIL]: (state, action) => (INITIAL_STATE),
    [ActionTypes.CHANGE_SUGGESTED_ORDER_INVALID_CODE]: (state, action) => {
      return action.payload ? {...state, 'invalidCode': action.payload} : INITIAL_STATE;
    },
    [ActionTypes.CHECK_PROVIDER_STOCK_ORDER_CODE_FAILED]: (state, action) => {
      const {error, payload} = action;
      const {data, status} = error;

      return {
        ...state,
        'invalidCode': payload.order.partCode,
        'invalidIndex': payload.values.row,
        'selectedOrder': payload.order,
        'selectedValues': payload.values,
        'errorCode': status,
        'errorDescription': data.error,
      };
    },
  })(state, action);
};
